import { Spinner } from "@/components/ui/Logo";

export function LoadingState({ label = "Lädt …" }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: 32,
        color: "var(--ink-3)",
        fontFamily: "Inter Variable, Inter, system-ui, sans-serif",
        flex: 1,
      }}
    >
      <Spinner color="var(--ink-3)" size={20} />
      <span style={{ fontSize: 13 }}>{label}</span>
    </div>
  );
}
